<div
  class="input-group input-group-sm float-end border border-dark rounded w-auto"
>
  <ng-content></ng-content>
  <input
    type="text"
    name="search-field"
    class="form-control border-0"
    data-test-selector="search-component-input"
    aria-label="Search"
    [tabIndex]="inputTabIndex"
    [(ngModel)]="searchText"
    [disabled]="disabled"
    (ngModelChange)="onSearch(searchText)"
    (keydown.enter)="searchSubmitted.emit(searchText)"
    [placeholder]="placeHolderText"
  />

  <div
    class="input-group-append input-group-text border-0"
    [ngClass]="{'bg-white' : !disabled}"
    id="inputGroup-sizing-sm"
  >
    <i
      *ngIf="!searchText"
      class="fas fa-search"
      (click)="onSearch(searchText)"
    ></i>
    <button
      *ngIf="searchText"
      type="button"
      class="btn border-0 p-0 bg-transparent text-reset"
      aria-label="Clear search"
      [disabled]="disabled"
      (click)="onClearSearch()"
    >
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
</div>
